import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { restoreDailyRelease } from "./engine/daily";
import { preservePendingDaily } from "./engine/persistence";
restoreDailyRelease();
preservePendingDaily();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => undefined);
    // Locale HTML is intentionally absent from install-time precache. Warm
    // only the pathname and same-origin resources used by this visit; this
    // keeps first-visit offline refresh complete without fetching other locales.
    const warmRuntimeCache = () => {
      const urls = performance.getEntriesByType("resource")
        .map((entry) => entry.name)
        .filter((name) => name.startsWith(location.origin));
      navigator.serviceWorker.controller?.postMessage({ type: "WARM_CACHE", urls: [location.pathname, ...urls] });
    };
    // Warm the current worker now and every replacement worker after it takes
    // control. The worker retains its predecessor's cache until this succeeds.
    navigator.serviceWorker.addEventListener("controllerchange", warmRuntimeCache);
    if (navigator.serviceWorker.controller) warmRuntimeCache();
  });
}
